import React from 'react';
import { useNewVersion } from '../hooks/useNewVersion';
import { Button } from '../ds/components/Button';

/** Baner „Jest nowa wersja panelu” — pojawia się po deployu, użytkownik sam odświeża (2026-09-15). */
export default function NewVersionBanner() {
  const available = useNewVersion();
  if (!available) return null;
  return (
    <div
      role="status"
      data-testid="new-version-banner"
      style={{
        position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 2000,
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 'var(--space-4)',
        padding: 'var(--space-3) var(--space-4)',
        background: 'var(--action-primary)', color: '#fff',
        fontFamily: 'var(--font-sans)', fontSize: 'var(--text-body)',
        boxShadow: '0 -2px 8px rgba(0,0,0,.25)',
      }}
    >
      <span>Jest nowa wersja panelu.</span>
      <Button variant="secondary" onClick={() => window.location.reload()}>Odśwież</Button>
    </div>
  );
}
